module.exports = __webpack_public_path__ + "img/xiangmu4.b718cfe6.png";